import { Scale } from 'lucide-react';

import { humanizeLabel } from '@/nucleo/displayLabels';
import { formatarData } from '@/nucleo/formato/datas';
import { EmptyState } from '@/ui/EmptyState';
import { Spinner } from '@/ui/Spinner';
import { StatusBadge, type StatusVariant } from '@/ui/StatusBadge';
import { Card, CardContent } from '@/ui/base/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui/base/table';

import { useRecursosDoCredenciado, type RecursoDoCredenciado } from './detalheDados';

interface AbaRecursosProps {
  credenciadoId: string;
}

const SELO_DO_RECURSO: Record<RecursoDoCredenciado['status_recurso'], StatusVariant> = {
  PROTOCOLADO: 'pendente',
  EM_ANALISE: 'pendente',
  DEFERIDO: 'aprovado',
  INDEFERIDO: 'rejeitado',
};

/**
 * Aba "Recursos" (administrativos). SEM CLIQUE NA LINHA DE PROPOSITO: o
 * protótipo levava a `/recursos/:id`, rota que nao existe aqui — ver o mesmo
 * raciocinio em `AbaTermos`.
 */
export function AbaRecursos({ credenciadoId }: AbaRecursosProps) {
  const { data: recursos, isLoading } = useRecursosDoCredenciado(credenciadoId);

  return (
    <Card>
      <CardContent className="p-6">
        {isLoading ? (
          <Spinner size="sm" />
        ) : !recursos || recursos.length === 0 ? (
          <EmptyState
            icon={Scale}
            title="Nenhum recurso"
            description="Recursos administrativos serão exibidos aqui."
          />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tipo</TableHead>
                <TableHead>Descrição</TableHead>
                <TableHead>Protocolo</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Decisão</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {recursos.map((recurso) => (
                <TableRow key={recurso.id}>
                  <TableCell>{humanizeLabel(recurso.tipo_recurso)}</TableCell>
                  <TableCell className="max-w-[220px] truncate">{recurso.descricao}</TableCell>
                  <TableCell>{formatarData(recurso.data_protocolo)}</TableCell>
                  <TableCell>
                    <StatusBadge
                      status={SELO_DO_RECURSO[recurso.status_recurso]}
                      label={recurso.status_recurso}
                    />
                  </TableCell>
                  <TableCell className="max-w-[160px] truncate">{recurso.decisao || '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
